exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.service-form .form-title[data-v-67b19deb]{\n  font-size: 28px !important;\n  margin-bottom: 30px !important;\n  text-transform: capitalize;\n}\n.service-form input[data-v-67b19deb]{\n  width: 100%!important;\n  height: 44px!important;\n}\n.service-form textarea[data-v-67b19deb]{\n  width: 100%!important;\n}\n.service-form.acquainted-form[data-v-67b19deb]{\n  padding: 30px!important;\n}\n.success-send-title[data-v-67b19deb]{\n\tfont-size: 24px;\n}\n@media (max-width: 470px){\n.service-form .form-title[data-v-67b19deb]{\n    font-size: 22px !important;\n    margin-bottom: 20px !important;\n}\n}\n", ""]);

// exports
